// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1ECxV","footer":"ReportModalFilter_footer__1K8QB"};